'use strict';

var findApp = require('./findApp');

function appProperty(obj) {
  if (!obj.hasOwnProperty('app')) {
    Object.defineProperty(obj, 'app', {
      get: function get() {
        return findApp(this);
      },
      set: function set() {}
    });
  }
}

module.exports = appProperty;

/* Do nothing until https://github.com/gaearon/react-hot-api/pull/16 is resolves */


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/appProperty.js
// module id = h5Sp
// module chunks = 88